const styles = {
    headerSecCtn: {
        backgroundColor: '#9DBACE',
        textAlign: 'center',
        paddingTop: '65px',
        paddingBottom: '40px'
    },
    
    headerSecHeader: {
        color: 'white',
        fontSize: '80px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat-Bold',
        marginTop: '10vw',
        marginBottom: '4vw'
    },

    headerSecInfo: {
        width: '90%',
        margin: 'auto',
        lineHeight: '25px',
        color: 'gray'
    },

    formSecCtn: {
        backgroundColor: 'white',
        width: '80%',
        margin: 'auto'
    },

    formSecContents: {
        width: '100%',
        paddingTop: '20px',
        paddingBottom: '20px',
        margin: 'auto'
    },

    formSecContentsHeader: {
        color: 'gray',
        fontSize: '14px',
        textAlign: 'center'
    },

    formSecContentsForm: {
        marginTop: '20px',
        marginBottom: '20px'
    },

    formSecContentsFormInput: {
        width: '90%',
        backgroundColor: '#D9D9D9',
        color: 'gray',
        border: 'none',
        padding: '10px 15px 10px 15px',
        textAlign: 'left',
        marginBottom: '20px'
    },

    formSecContentsFormBtn: {
        margin: 'auto',
        width: '150px',
        paddingTop: '10px',
        paddingBottom: '10px',
        textAlign: 'center',
        backgroundColor: '#9DBACE',
        color: 'white',
        fontSize: '10px',
        borderRadius: '20px',
        userSelect: 'none',

        ':hover': {
            cursor: 'pointer'
        },

        ':active': {
            position: 'relative',
            top: '1px',
            left: '1px'
        }
    },

    formSecContentsFooter: {
        marginTop: '40px',
        textAlign: 'center'
    },

    formSecContentsFooterHeader: {
        fontFamily: 'Montserrat-Bold',
        fontWeight: 'bold',
        fontSize: '12px',
        color: 'black',
        marginBottom: '10px'
    },

    formSecContentsFooterInfo: {
        fontWeight: 'normal',
        fontSize: '12px',
        color: 'gray'
    },

    formSecContentsFooterInfoLink: {
        textDecoration: 'none',
        fontWeight: 'normal',
        fontSize: '12px',
        color: 'gray',

        ':hover': {
            textDecoration: 'underline'
        }
    },

    locationSec: {
        height: '120px',
        position: 'relative'
    },

    locationSecOverlay: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: '10',
        backgroundColor: '#9DBACE',
        opacity: '0.6',
        top: '0',

        ':hover': {
            cursor: 'pointer'
        }
    }
}

export default styles;